<template>
  <div class="login mainWrap">
    <el-row style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <el-col :span="15" class="loginWrap">
        <div class="loginbg"></div>
      </el-col>
      <el-col :span="9" class="loginWrap rightWrap">
        <div class="innerWrap">
          <p class="title"><img src="../assets/img/login/sxy.png"><span>{{$t('login.topTitleLeft')}}</span>{{$t('login.topTitleRight')}}</p>
          <div class="formWrap" v-show='loginType ===1 || loginType ===3'>
            <!-- tab切换 -->
            <div class="titleTab">
              <div class="tabSelect">{{$t('login.title2')}}</div>
            </div>
            <!-- 验证码登录 -->
            <el-form @keyup.enter.native="submitPhoneForm('Phoneform')"  ref="Phoneform" class="loginForm" :model="Phoneform" :rules="phoneRules" label-width="0px">
                <el-form-item prop="phone" style="height:40px;">
                  <el-input v-model="Phoneform.phone" :placeholder="$t('login.placehoder1')">
                    <el-select style="width:100px;" slot="prepend" v-model="Phoneform.place">
                      <el-option label="+86" value="1"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
                <div class="appointment" v-show ='contactHint'>
                  <p>{{$t('login.bindTips')}}</p>
                  <a target="_blank" href="https://docs.qq.com/form/fill/DZGFCYkNIRHp3SEhX?_w_tencentdocx_form=1">{{$t('login.contactBtn')}}</a>
                </div>
                <el-form-item prop="code" style="height:40px;">
                  <el-input v-model="Phoneform.code" :placeholder="$t('login.placehoder3')">
                    <el-button slot="append" :disabled='getCodeBtn' @click="getCodefun()">{{codeMsg}}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div>
                    <el-checkbox v-model="checked">{{$t('login.remember')}}</el-checkbox>
                  </div>
                  <el-button type="primary" class="submitBtn" @click="submitPhoneForm('Phoneform')">{{$t('login.login')}}</el-button>
                </el-form-item>
              </el-form>
              <!-- 新加二维码登录 -->
              <div class='separate'>
                <p class='word'>{{$t('login.or')}}</p>
                <p class='line'></p>
              </div>
              <div class='icons'>
                <div class="scanBtn wx" @click='wxCodeLogin'>
                  <img src="../assets/img/login/wx.png">
                  <span>{{$t('login.scanbtn')}}</span>
                </div>
                <div class="scanBtn workwx" @click='dingdingCodeLogin'>
                  <img src="../assets/img/login/dingding.png">
                  <span>{{$t('login.scanbtn2')}}</span>
                </div>
                <!-- <img @click='wxCodeLogin' src='../assets/img/login/icon1.jpg'> -->
                <!-- <img @click='workWxCodeLogin' src='../assets/img/login/icon2.jpg'> -->
                <!-- <img @click='dingdingCodeLogin' src='../assets/img/login/icon3.jpg'> -->

              </div>
          </div>
        <!-- 微信登录弹出框 -->
        <div class="codePopup" v-show='loginType ===2'>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.wxTitle')}}</div>
          </div>
          <!-- 二维码 -->
          <div id="wxCodeWrap" v-loading="wxCodeloading">
            <img :src='wxCodeSrc' >
            <p>{{$t('login.wxTips')}}</p>
          </div> 
          <!-- 其他登录方式 -->
          <div class='separate'>
            <p class='word'>{{$t('login.or')}}</p>
            <p class='line'></p>
          </div>
          <div class='icons'>
            <span @click='loginType=1'>{{$t('login.title2')}}</span>
            <!-- <img @click='workWxCodeLogin' src='../assets/img/login/icon2.jpg'> -->
            <img @click='dingdingCodeLogin' src='../assets/img/login/icon3.jpg'>
          </div>
        </div>
        <!-- 企业微信登录弹出框 loginType === 3 -->
        <div class="codePopup" v-if='false'>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.EnterpriseWxTitle')}}</div>
          </div>
          <!-- 二维码 -->
          <div id="workWxCodeWrap"></div> 
          <!-- 其他登录方式 -->
          <div class='separate'>
            <p class='word'>{{$t('login.or')}}</p>
            <p class='line'></p>
          </div>
          <div class='icons'>
            <span @click='loginType=1' >{{$t('login.title2')}}</span>
            <img @click='wxCodeLogin' src='../assets/img/login/icon1.jpg'>
            <img @click='dingdingCodeLogin' src='../assets/img/login/icon3.jpg'>
          </div>
        </div>
        <!-- 钉钉登录弹出框 -->
        <div class="codePopup" v-show='loginType === 4'>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.dingTitle')}}</div>
          </div>
          <!-- 二维码 -->
          <div id="dingdingCodeWrap"></div>
          <!-- 其他登录方式 -->
          <div class='separate'>
            <p class='word'>{{$t('login.or')}}</p>
            <p class='line'></p>
          </div>
          <div class='icons'>
            <span @click='loginType=1'>{{$t('login.title2')}}</span>
            <img @click='wxCodeLogin' src='../assets/img/login/icon1.jpg'>
            <!-- <img @click='workWxCodeLogin' src='../assets/img/login/icon2.jpg'> -->
          </div>
        </div>
        <!-- 绑定微信弹出框 -->
        <div class="codePopup" v-show='loginType === 5'>
          <i class="el-icon-close closeBtn"  @click='closeWXBind()'></i>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.bindtitle1')}}</div>
          </div>
          <el-form @keyup.enter.native="submitBindWX('BindWXform')"  ref="BindWXform" class="loginForm" :model="BindWXform" :rules="phoneRules" label-width="0px">
            <el-form-item prop="bindWXPhone" style="height:40px;">
              <el-input v-model="BindWXform.bindWXPhone" :placeholder="$t('login.placehoder1')">
                <el-select style="width:100px;" slot="prepend" v-model="BindWXform.place">
                  <el-option label="+86" value="1"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <div class="appointment"  v-show ='contactHint'>
              <p>{{$t('login.bindTips')}}</p>
              <a target="_blank" href="https://docs.qq.com/form/fill/DZGFCYkNIRHp3SEhX?_w_tencentdocx_form=1">{{$t('login.contactBtn')}}</a>
            </div>
            <el-form-item prop="code" style="height:40px;">
              <el-input v-model="BindWXform.code" :placeholder="$t('login.placehoder3')">
                <el-button slot="append" :disabled='getBindWXformCode' @click="getWXCodefun()">{{codeMsg2}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              
              <el-button type="primary" class="submitBtn" @click="submitBindWX('BindWXform')">{{$t('login.login')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 绑定企业微信弹出框 -->
        <div class="codePopup" v-show='loginType === 6'>
          <i class="el-icon-close closeBtn" @click='closeBind'></i>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.bindtitle2')}}</div>
          </div>
          <el-form @keyup.enter.native="submitBindWorkWX('BindWorkWXform')"  ref="BindWorkWXform" class="loginForm" :model="BindWorkWXform" :rules="phoneRules" label-width="0px">
            <el-form-item prop="bindWorkWXPhone" style="height:40px;">
              <el-input v-model="BindWorkWXform.bindWorkWXPhone" :placeholder="$t('login.placehoder1')">
                <el-select style="width:100px;" slot="prepend" v-model="BindWorkWXform.place">
                  <el-option label="+86" value="1"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <div class="appointment" v-show ='contactHint'>
              <p>{{$t('login.bindTips')}}</p>
              <a target="_blank" href="https://docs.qq.com/form/fill/DZGFCYkNIRHp3SEhX?_w_tencentdocx_form=1">{{$t('login.contactBtn')}}</a>
            </div>
            <el-form-item prop="code" style="height:40px;">
              <el-input v-model="BindWorkWXform.code" :placeholder="$t('login.placehoder3')">
                <el-button slot="append" :disabled='getBindWorkWXformCode' @click="getWorkWXCodefun()">{{codeMsg3}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              
              <el-button type="primary" class="submitBtn" @click="submitBindWorkWX('BindWorkWXform')">{{$t('login.login')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 绑定钉钉弹出框 -->
        <div class="codePopup" v-show='loginType === 7'>
          <i class="el-icon-close closeBtn"  @click='closeBind'></i>
          <div class="titleTab">
            <div class="tabSelect">{{$t('login.bindtitle3')}}</div>
          </div>
          <el-form @keyup.enter.native="submitBindDingding('BindDingdingform')"  ref="BindDingdingform" class="loginForm" :model="BindDingdingform" :rules="phoneRules" label-width="0px">
            <el-form-item prop="bindDingdingPhone" style="height:40px;">
              <el-input v-model="BindDingdingform.bindDingdingPhone" :placeholder="$t('login.placehoder1')">
                <el-select style="width:100px;" slot="prepend" v-model="BindDingdingform.place">
                  <el-option label="+86" value="1"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <div class="appointment" v-show ='contactHint'>
              <p>{{$t('login.bindTips')}}</p>
              <a target="_blank" href="https://docs.qq.com/form/fill/DZGFCYkNIRHp3SEhX?_w_tencentdocx_form=1">{{$t('login.contactBtn')}}</a>
            </div>
            <el-form-item prop="code" style="height:40px;">
              <el-input v-model="BindDingdingform.code" :placeholder="$t('login.placehoder3')">
                <el-button slot="append" :disabled='getBindDingformCode' @click="getdingdingCodefun()">{{codeMsg4}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              
              <el-button type="primary" class="submitBtn" @click="submitBindDingding('BindDingdingform')">{{$t('login.login')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
        <!-- 底部备案链接 -->
        <div class="bottomLink">
          <span>Copyright ©2019 tst-cloud.com</span>
          <a href="http://beian.miit.gov.cn/" target="_blank">津ICP备14002507号-5</a>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="selectFactory"
      width="700px"
      :title="$t('login.selectfactory')"
      class="selectfactory"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :closeOnPressEscape='false'>
      <div class="loginbox">
        <el-scrollbar style="height:100%">
          <div class="content">
            <div class="itembox" v-for="(item,index) in AllTenants" :key="index" @click="selectFactoryitem(item)" :class="item.tenantCode == selectcode ? 'isActive' : ''">
              <img :src="item.tenantFactoryIcon" alt="">
              <p v-if="$store.state.lang===1">{{item.tenantShortName}}</p>
              <p v-else>{{item.tenantShortNameEn}}</p>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wechatIcon from "vue-material-design-icons/Wechat.vue"
import lockIcon from "vue-material-design-icons/Lock.vue"
import { Loading } from 'element-ui'
export default {
  name: 'login',
  components: {
    wechatIcon,
    lockIcon
  },
  data () {
    let _this = this
		var checkPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
        _this.getCodeBtn = false
        callback()
      } else if (!value) {
        _this.getCodeBtn = true
        callback(new Error(_this.$t('login.error1')))
      } else {
        _this.getCodeBtn = true
        callback(new Error(_this.$t('login.error3')))
      }
    }
    var checkwxPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
        _this.getBindWXformCode = false
        callback()
      } else if (!value) {
        _this.getBindWXformCode = true
        callback(new Error(_this.$t('login.error1')))
      } else {
        _this.getBindWXformCode = true
        callback(new Error(_this.$t('login.error3')))
      }
    }
    var checkWorkwxPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
        _this.getBindWorkWXformCode = false
        callback()
      } else if (!value) {
        _this.getBindWorkWXformCode = true
        callback(new Error(_this.$t('login.error1')))
      } else {
        _this.getBindWorkWXformCode = true
        callback(new Error(_this.$t('login.error3')))
      }
    }
    var checkdingPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
        _this.getBindDingformCode = false
        callback()
      } else if (!value) {
        _this.getBindDingformCode = true
        callback(new Error(_this.$t('login.error1')))
      } else {
        _this.getBindDingformCode = true
        callback(new Error(_this.$t('login.error3')))
      }
		}
		return {
      // 验证码登录
      Phoneform:{
        phone: '',
        place: '1',
        code: ''
      },
      phoneRules:{
        phone: [
          { validator: checkPhone, trigger: 'change' }
        ],
        bindWXPhone:[
          { validator: checkwxPhone, trigger: 'change' }
        ],
        bindWorkWXPhone:[
          { validator: checkWorkwxPhone, trigger: 'change' }
        ],
        bindDingdingPhone:[
          { validator: checkdingPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: this.$t('login.error5'), trigger: 'blur' },
        ]
      },
      // 验证码倒计时时间
      codeTime: 60,
      codeMsg: this.$t('login.getMsg'),
      getCodeBtn: true,
      // 是否保存登录状态
      checked: false,
      // 登录方式
      loginType: 1,
      // 绑定微信
      BindWXform:{
        bindWXPhone: '',
        place: '1',
        code: ''
      },
      // 绑定企业微信
      BindWorkWXform:{
        bindWorkWXPhone: '',
        place: '1',
        code: ''
      },
      // 绑定钉钉
      BindDingdingform:{
        bindDingdingPhone: '',
        place: '1',
        code: ''
      },
      // 绑定微信短信倒计时
      codeTime2: 60,
      codeMsg2: this.$t('login.getMsg'),
      getBindWXformCode: true,
      // 绑定企业微信短信倒计时
      codeTime3: 60,
      codeMsg3: this.$t('login.getMsg'),
      getBindWorkWXformCode: true,
      // 绑定钉钉短信倒计时
      codeTime4: 60,
      codeMsg4: this.$t('login.getMsg'),
      getBindDingformCode: true,
      // 扫码成功后获取到的数据
      parameters: {},
      // 扫码后返回的openid
      returnOpenID: '',
      // 预约提示
      contactHint:false,
      // 微信二维码路径
      wxCodeSrc: '',
      websock: '',
      wxCodeloading:false,
      dingdingNick: '',
      //工厂名称
      fName: '',
      countDown: '',

      // 所有的工厂
      AllTenants:[],
      // 选择工厂弹框
      selectFactory:false,
      //dialog去掉关闭按钮
      showClo:false,
      selectcode:'',
      savedata:'',
      accountId:''
		}
  },
  mounted(){
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }else{
      var address = window.location.host.split(".")
      this.fName = address[0]
      this.getParameter(window.location.search)
      setTimeout(() => {
        if(localStorage.getItem('loginType') === '3'){
          this.workWxCodeLogin()
        } else if (localStorage.getItem('loginType') === '4') {
          this.dingdingCodeLogin()
        } else if (localStorage.getItem('loginType') === '2'){
          this.wxCodeLogin()
        }
      })
    }
  },
  destroyed () {
    if (this.websock!==''){
      this.websock.close()
    }
  },
  methods: {
    // 获取url参数
    getParameter(url){
      this.parameters = {}
      let _this = this
      if (url !== '') {
        new Promise(function(resolve) {
          let parameterArr = url.substr(1).split("&")
          for(let item of parameterArr){
            let resArr = item.split("=")
            _this.parameters[resArr[0]] = resArr[1]
          }
          resolve();
        }).then(function() {
          if (_this.parameters.state === 'workWx'){
            _this.workWxLogin()
          }else if (_this.parameters.state === 'dingding'){
            _this.dingdingQRLogin()
          }
        })
      } 
    },
    // 短信登录获取密码倒计时
    codeTiming(){
      if (this.codeTime === 0) {
        this.codeMsg = this.$t('login.getMsg')
        this.codeTime = 60
        this.getCodeBtn = false
      } else {
        this.getCodeBtn = true
        this.codeTime--
        this.codeMsg = '(' + this.codeTime + 's)'
        setTimeout(this.codeTiming, 1000)
      }
    },
    // 点击获取短信按钮
    getCodefun(){
      let _this = this
      this.getCodeBtn = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.Phoneform.phone,
          type: 1,
          language: Number(this.$store.state.lang)
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.contactHint = false
          _this.codeTiming()
        } else {
          _this.getCodeBtn = false
          if (res.data.ishave === false) {
            _this.contactHint = true
          }
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 短信登录登录按钮
    submitPhoneForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/codeLogin',
            params:{
              phone: _this.Phoneform.phone,
              code: _this.Phoneform.code,
              remeberMe: _this.checked,
              language: Number(this.$store.state.lang)
            }
          }).then(function(res){
            if (res.data.success === 'false') {
              _this.$message.error(res.data.msg)
            } else {
              _this.accountId=res.data.account.id
              localStorage.loginType = '1'
              _this.savedata=res.data
              _this.getAllTenants()
            }
            loadingInstance.close()
          })

        } else {
          return false
        }
      })
    },
    //添加grafana用户
    createGrafanaUser(){
      let _this= this
      this.axios({
        method:'get',
        url:'/url/createUserPutOrg/'+this.accountId+'/'+this.selectcode
      }).then((res)=>{
        if(res.data.success === 'true'){
          console.log(res.data)
        }else{
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 获取机器信息
    getDefaultMachine(data){
      let _this= this
      this.axios({
        method:'post',
        url:'/url/getDefaultMachine',
        data:data
      }).then((res)=>{
        if(res.status===200 && res.data.success=='true'){
          _this.$store.commit('loginId',res.data)
          if(localStorage.jumpPage){
            var jump = localStorage.jumpPage
            localStorage.removeItem("jumpPage")
            window.location.href = 'http://' + jump
          }else{
            window.location.href = '/'
          }
        }else{
          _this.$message.error(res.data.msg)
          _this.$store.commit('loginOut')
        }
      })
    },
    // 获取所有的工厂
    getAllTenants(){
      let _this = this
      this.axios({
        method:'get',
        url:'/url/findTenantsByAccountId',
        params:{
          language: Number(_this.$store.state.lang),
          userId:_this.savedata.account.id
        }
      }).then((res)=>{
        if(res.data.success==='true'){
          if(res.data.TenantInfoList.length>1){
            _this.selectFactory=true
            _this.AllTenants=res.data.TenantInfoList
          }else{
            _this.selectcode=res.data.TenantInfoList[0].tenantCode
            _this.$store.commit('login', _this.savedata)
            if (_this.selectcode==='tstmanage') { // 赛象管理工厂跳转到指定页面
              window.location.href = '/VPN001'
            } else {
              _this.getDefaultMachine(_this.savedata)
              _this.createGrafanaUser()
            }
          }
        }else{
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 选择了工厂之后去登录
    selectFactoryitem(item){
      this.selectcode=item.tenantCode
      this.selectFactory=false
      if(this.selectcode==='zhongce'){
        this.createGrafanaUser()
        window.location.href="http://hangzhoupt.tst-cloud.com/login"
      }else if(this.selectcode==='tstmanage'){ // 赛象管理工厂跳转到指定页面
        this.$store.commit('login', this.savedata)
        this.$store.commit('loginRoute',item.tenantCode)
        window.location.href = '/VPN001'
      }else{
        this.createGrafanaUser()
        this.$store.commit('login', this.savedata)
        this.$store.commit('loginRoute',item.tenantCode)
        this.getDefaultMachine(this.savedata)
      }
    },
    // 微信二维码扫描登录
    wxCodeLogin(){
      var nameId = 100
      if (this.fName === 'jiande') {
        nameId = 100
      }else if (this.fName === 'guilun'){
        nameId = 101
      }else if (this.fName === 'xinjiang'){
        nameId = 102
      }
      this.loginType = 2
      this.contactHint=false
      this.$refs['Phoneform'].resetFields();
      this.wxCodeloading=true
      // 生成唯一数字 （时间戳+ip+随机数）
      let num1 = this.randomNum();
      let num2 = this.randomNum();
      // let cityIp = window.returnCitySN["cip"].split(".").join("")
      // let ownID = new Date().getTime()/2 + (Number(num1) + Number(num2) + Number(cityIp))/2
      let ownID = new Date().getTime()/2 + (Number(num1) + Number(num2))/2
      let randomID = nameId + String(parseInt(ownID)).substring(String(parseInt(ownID)).length-6)
      this.getQRcode(randomID)
    },
    // 获取随机数
    randomNum(){
      var Num=""; 
      for(var i=0;i<6;i++) { 
        Num+=Math.floor(Math.random()*10); 
      }
      return Num
    },
    // 获取公众号二维码
    getQRcode(id){
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getQrcode',
        params:{
          sceneId: id
        }
      }).then(function(res){
        _this.wxCodeSrc = res.data.path
        _this.wxCodeloading=false
      }).then(function(){
        _this.initWebSocket(id)
      })
    },
    // 获取成功后立即建立websocket连接
    initWebSocket(id){
      let _this = this
      _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+ "wechat/websocket/"+id)
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        let info = JSON.parse(e.data)
        if (info.success === true) {
          _this.wxQRCodeLogin(info.openid)
        }
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+ "wechat/websocket/"+id)
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 微信二维码登录
    wxQRCodeLogin(openid){
      let _this = this
      let loadingInstance = Loading.service({ fullscreen: true })
      this.axios({
        method: 'post',
        url: '/url/wechatLogin',
        params:{
          openid:openid,
          remeberMe: _this.checked,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true' && res.data.islogin ===false){
          _this.loginType = 5
          _this.returnOpenID = res.data.openid
        } else if (res.data.success === 'true' && res.data.islogin ===true){
          _this.accountId=res.data.account.id
          localStorage.loginType = 2
           _this.savedata=res.data
          _this.getAllTenants()
        }else if (res.data.success === 'false'){
          _this.$message.error(res.data.msg);
        }
        loadingInstance.close()

      })
    },
    // 企业微信扫码登录
    workWxCodeLogin(){
      this.loginType = 3
      this.contactHint=false
      this.$refs['Phoneform'].resetFields();
      window.workWxLogin()
    },
    // 钉钉扫码登录
    dingdingCodeLogin(){
      this.loginType = 4
      this.contactHint=false
      this.$refs['Phoneform'].resetFields();
      window.dingdingLogin()
      var appId,redirectUri
      appId = 'dingfzw4mrtgnf5qknk5'
      redirectUri = 'http%3A%2F%2Fwww.tst-cloud.com/login'
      
      let handleMessage = function (event) {
        let origin = event.origin;
        if( origin == "https://login.dingtalk.com" ) { //判断是否来自ddLogin扫码事件。
          let loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          let url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=dingding&redirect_uri=${redirectUri}&loginTmpCode=${loginTmpCode}`
          window.location.href = url
        }
      };
      if (typeof window.addEventListener != 'undefined') {
          window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
          window.attachEvent('onmessage', handleMessage);
      }
    },
    // 企业微信扫码完成后返回处理
    workWxLogin(){
      let _this = this
      let loadingInstance = Loading.service({ fullscreen: true })
      this.axios({
        method: 'post',
        url: '/url/enterpriseWechatLogin',
        params:{
          code: _this.parameters.code,
          state: _this.parameters.state,
          remeberMe: _this.checked,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true' && res.data.islogin ===false){
          _this.loginType = 6
          _this.returnOpenID = res.data.openid
        } else if (res.data.success === 'true' && res.data.islogin ===true){
          localStorage.loginType = '3'
          _this.accountId=res.data.account.id
          _this.savedata=res.data
          _this.getAllTenants()
        }else if (res.data.success === 'false'){
          _this.$message.error(res.data.msg);
        }
        loadingInstance.close()
      })
    },
    // 钉钉扫码完成后返回处理
    dingdingQRLogin(){
      let _this = this
      let loadingInstance = Loading.service({ fullscreen: true })
      this.axios({
        method: 'post',
        url: '/url/dingtalkLogin',
        params:{
          code: _this.parameters.code,
          state: _this.parameters.state,
          remeberMe: _this.checked,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true' && res.data.islogin ===false){
          _this.loginType = 7
          _this.returnOpenID = res.data.openid
          _this.dingdingNick = res.data.nick
        } else if (res.data.success === 'true' && res.data.islogin ===true){
          localStorage.loginType = '4'
          _this.accountId=res.data.account.id
          _this.savedata=res.data
          _this.getAllTenants()
        }else if (res.data.success === 'false'){
          _this.$message.error(res.data.msg);
        }
        loadingInstance.close()
      })
    },
    // 绑定微信表单验证
    submitBindWX(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/wechatBind',
            params:{
              phone: _this.BindWXform.bindWXPhone,
              code: _this.BindWXform.code,
              openid: _this.returnOpenID,
              remeberMe: _this.checked,
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'true') {
              localStorage.loginType = '2'
              _this.accountId=res.data.account.id
                _this.savedata=res.data
                _this.getAllTenants()
            }else {
              _this.$message.error(res.data.msg)
            }
            loadingInstance.close()
          })
        } else {
          return false
        }
      })
    },
    // 获取绑定短信
    getWXCodefun(){
      let _this = this
      this.getBindWorkWXformCode = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.BindWXform.bindWXPhone,
          type: 1,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.contactHint = false
          _this.codeTiming2()
        } else {
          _this.getBindWXformCode = false
          if (res.data.ishave === false) {
            _this.contactHint = true
          }
          _this.$message.error(res.data.msg)
        }
      })
    },
    codeTiming2(){
      if (this.codeTime2 === 0) {
        this.codeMsg2 = this.$t('login.getMsg')
        this.codeTime2 = 60
        this.getBindWXformCode = false
      } else {
        this.getBindWXformCode = true
        this.codeTime2--
        this.codeMsg2 = '(' + this.codeTime2 + 's)'
        this.countDown = setTimeout(this.codeTiming2, 1000)
      }
    },
    // 绑定企业微信表单验证
    submitBindWorkWX(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/enterpriseWechatBind',
            params:{
              phone: _this.BindWorkWXform.bindWorkWXPhone,
              code: _this.BindWorkWXform.code,
              openid: _this.returnOpenID,
              remeberMe: _this.checked,
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'true') {
              localStorage.loginType = '3'
              _this.accountId=res.data.account.id
              _this.savedata=res.data
              _this.getAllTenants()
            }else {
              _this.$message.error(res.data.msg)
            }
            loadingInstance.close()
          })
        } else {
          return false
        }
      })
    },
    // 获取绑定短信
    getWorkWXCodefun(){
      let _this = this
      this.getBindWorkWXformCode = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.BindWorkWXform.bindWorkWXPhone,
          type: 1,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.contactHint = false
          _this.codeTiming3()
        } else {
          _this.getBindWorkWXformCode = false
          if (res.data.ishave === false) {
            _this.contactHint = true
          }
          _this.$message.error(res.data.msg)
        }
      })
    },
    codeTiming3(){
      if (this.codeTime3 === 0) {
        this.codeMsg3 = this.$t('login.getMsg')
        this.codeTime3 = 60
        this.getBindWorkWXformCode = false
      } else {
        this.getBindWorkWXformCode = true
        this.codeTime3--
        this.codeMsg3 = '(' + this.codeTime3 + 's)'
        setTimeout(this.codeTiming3, 1000)
      }
    },
    // 绑定钉钉表单验证
    submitBindDingding(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/dingtalkBind',
            params:{
              phone: _this.BindDingdingform.bindDingdingPhone,
              code: _this.BindDingdingform.code,
              openid: _this.returnOpenID,
              nick: _this.dingdingNick,
              remeberMe: _this.checked,
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'true') {
              localStorage.loginType = '4'
              _this.accountId=res.data.account.id
              _this.savedata=res.data
              _this.getAllTenants()
            }else {
              _this.$message.error(res.data.msg)
            }
            loadingInstance.close()
          })
        } else {
          return false
        }
      })
    },
    // 获取绑定短信
    getdingdingCodefun(){
      let _this = this
      this.getBindDingformCode = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.BindDingdingform.bindDingdingPhone,
          type: 1,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.contactHint = false
          _this.codeTiming4()
        } else {
          _this.getBindDingformCode = false
          if (res.data.ishave === false) {
            _this.contactHint = true
          }
          _this.$message.error(res.data.msg)
        }
      })

    },
    codeTiming4(){
      if (this.codeTime4 === 0) {
        this.codeMsg4 = this.$t('login.getMsg')
        this.codeTime4 = 60
        this.getBindDingformCode = false
      } else {
        this.getBindDingformCode = true
        this.codeTime4--
        this.codeMsg4 = '(' + this.codeTime4 + 's)'
        setTimeout(this.codeTiming4, 1000)
      }
    },
    closeWXBind(){
      this.loginType = 1
      this.contactHint=false
      this.$refs['BindWXform'].resetFields();
      this.codeMsg2 = this.$t('login.getMsg')
      this.codeTime2 = 60
      this.getBindWXformCode = true
      clearTimeout(this.countDown)
    },
    // 关闭绑定页
    closeBind(){
      this.loginType = 1
      this.contactHint=false
    }
  }
}
</script>
<style scoped>
.login{
  width: 100%;
  height: 100%;
  min-height: 750px;
  background-color:#E7EBF1;
}
.loginbg{
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/login/bg.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 115%;
  filter: brightness(110%) opacity(80%);
}
.loginbg p{
  visibility: hidden;
}
.loginWrap{
  height: 100%;
}
.rightWrap{
  position: relative;
}
.rightWrap .innerWrap{
  width: 80%;
  min-width:366px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.innerWrap .title{
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  /* width: 400px; */
  margin: 0 auto;
  color: #505050;
  margin-bottom:40px; 
}
.innerWrap .title span{
  color: #6772e5;
}
.innerWrap .title img{
  width: 70px;
  margin-right: 10px;
  vertical-align: middle;
}
.innerWrap .formWrap{
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.13);
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}

.titleTab{
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
}
.titleTab div{
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 15px;
  margin-bottom: 50px;
  margin-top: 30px;
  font-size: 17px;
}
.codePopup .titleTab div{
   margin-bottom: 0px;
}
.titleTab .tabSelect{
  color: #6772e5;
  border-bottom: 1px solid #6772e5!important;
}
.loginForm{
  width: 80%;
  margin: 0 auto;
}
.submitBtn{
  width: 100%;
  line-height: 25px;
  font-size: 18px;
  margin-top: 15px;
}

.changePwd .RsetWrap{
  width: 300px;
  margin: 50px auto 0;
}
.rsetSubmit{
  width: 200px;
  line-height: 25px;
  font-size: 18px;
  margin-top: 30px;
}
.previous{
  width: 90px;
  line-height: 25px;
  font-size: 18px;
}
.showChange{
  color:rgba(103, 114, 229, 1);
  cursor: pointer;
}
.bottomLink{
  width: 360px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
}
.bottomLink span{
  margin-right: 10px;
}
.bottomLink a{
  color: rgba(103, 114, 229, 1);
}
.separate{
 text-align: center;
 height: 30px;
 line-height: 30px;
 width: 80%;
 margin: 0 auto
}
.separate .line{
  border-top: 1px solid #c0c0c0;
  margin-top: -15px;
}
.separate .word{
  display: inline-block;
  width: 37px;
  background-color: #fff;
}
.icons{
  text-align: center;
  margin: 10px 0 30px
}
.icons img{
  width: 25px;
  height: 25px;
  margin: 0 10px;
  cursor: pointer;
   display: inline-block;
  vertical-align: middle;
}
.icons span{
  font-size: 12px;
  color: rgba(128, 128, 128, 1);
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  border-right: 1px solid rgba(128, 128, 128, 1);
  margin-right: 10px;
  padding-right: 20px;
}
.icons .scanBtn{
  width: 80%;
  margin: 0 auto;
  border-radius: 3px;
  margin-bottom: 15px;
  padding: 10px 5px;
  cursor: pointer;
}
.icons .scanBtn span{
  color: #fff;
  border: none;
  font-size: 16px;
}
.icons .wx{
  background-color: #07c160;
}
.icons .workwx{
  background-color: #0089ff;
}
.codePopup{
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.13);
  padding: 10px;
  box-sizing: border-box;
  height: 488px;
}
#wxCodeWrap, #workWxCodeWrap, #dingdingCodeWrap{
  width: 100%;
  height: 315px;
  text-align:center;
  overflow:hidden;
}
.codePopup .loginForm{
  margin-top: 50px;
}
.appointment{
  margin-bottom: 30px;
}
.appointment p{
  font-size: 14px;
  color:rgba(255, 0, 0, 1);
  line-height: 16px;
}
.appointment a{
  font-size: 14px;
  color:rgba(255, 0, 0, 1);
  line-height: 16px;
  font-weight: bold;
  float: right;
  text-decoration: underline;
}
.closeBtn{
  cursor:pointer;
  font-size:25px!important;
  position:absolute;
  color:#c0c0c0;
  right:10px;
}
#wxCodeWrap img{
  display:inline-block;
  width:210px;
  height:210px;
  margin:30px 0 30px;
}
#wxCodeWrap p{
  font-size:14px;
  color:rgba(128, 128, 128, 1);
}
.isActive{
  background:#94afda!important;
}
.selectfactory .loginbox{
  background:#fff;
}
.selectfactory .loginbox .content{
  width:600px;
  height:460px;
  display:flex;
  flex-wrap: wrap;
  justify-content:flex-start;
  padding:20px 50px;
}
.content:after {content: ""; width: 300px; }

.selectfactory .loginbox .itembox{
  background:#e4e8f1;
  margin-right:10px;
  width:120px;
  height:120px;
  border-radius:10px;
  padding:10px 10px;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom:20px;
}
.selectfactory .loginbox .itembox:nth-child(4n){
  margin-right:0;
}
.selectfactory .loginbox .itembox img{
  width:100%;
}
.selectfactory .loginbox .itembox p{
  width:100%;
  background:#2254e4;
  text-align:center;
  border-radius:10px;
  color:#fff;
  font-size:18px;
  margin-bottom:5px;
}
</style>
